import React, { FunctionComponent } from 'react';
import type { CompanyDetailBrandsChildProps } from './types';
import type { CompanyBrandName } from '../../../types/companyDetail';

type Props = CompanyDetailBrandsChildProps & {
  name?: CompanyBrandName;
  image?: string;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  coverNoImg,
  dataCategory,
  dataValue,
  name,
  image,
}) => {
  const brandImage = image || coverNoImg;
  const altText = name?.truncated || 'ブランド画像';

  return (
    <a
      href={`/brands/${id}`}
      className="company__page__recruitments__wrapper__item gtm-brand-view-count"
      data-event-name='brand on screen'
      data-event="click"
      data-category={dataCategory}
      data-value={dataValue}
    >
      <div className="company__page__recruitments__wrapper__item--cover">
        <img src={brandImage} alt={altText} />
      </div>
      <div className="company__page__recruitments__wrapper__item__box">
        {name && (
          <p className="company__page__recruitments__wrapper__item__box--title">
            {`${name.truncated} | ${name.full}`}
          </p>
        )}
      </div>
    </a>
  );
};
